import { render, staticRenderFns } from "./rectification_form.vue?vue&type=template&id=116f413b"
import script from "./rectification_form.vue?vue&type=script&lang=js"
export * from "./rectification_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports